
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { GeometryInformation } from "../models/edit-models";
import { TabsComponent } from "../../../../../tabs/tabs.component";
import { TabComponent } from "../../../../../tabs/tab/tab.component";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-information-popup",
    templateUrl: "./information-popup.component.html",
    styleUrls: ["./information-popup.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TabsComponent,
        TabComponent,
        NgbTooltip
    ]
})
export class InformationPopupComponent {
    geoinfos: GeometryInformation[];

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("data")
    set data(value: GeometryInformation[]) {
        this.geoinfos = value;
    }

    getTooltip(keyvalue: any): string {
        return `${keyvalue.key} ${keyvalue.value}`;
    }

    isUrl(value: any): boolean {
        if (ObjectUtils.hasValue(value) && ObjectUtils.isString(value)) {
            return (value.startsWith("http://") || value.startsWith("https://"));
        }
        return false;
    }
}
